/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportConnectRudoApiKeyMutationRequest, SocialExportConnectRudoApiKeyMutationResponse, SocialExportConnectRudoApiKey400, SocialExportConnectRudoApiKey401, SocialExportConnectRudoApiKey403 } from "../models/SocialExportConnectRudoApiKey";

export function getSocialExportConnectRudoApiKeyUrl() {
  const res = { method: 'POST', url: `/social-export/v1/auth/rudo/api-key` as const }
  return res
}

/**
 * @description Creates a client-owned Rudo connection using a static access token. Assign the connection to stations separately.
 * @summary Connect Rudo with an access token
 * {@link /social-export/v1/auth/rudo/api-key}
 */
export async function socialExportConnectRudoApiKey(data: SocialExportConnectRudoApiKeyMutationRequest, config: Partial<RequestConfig<SocialExportConnectRudoApiKeyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, SocialExportConnectRudoApiKeyMutationRequest>({ method : "POST", url : getSocialExportConnectRudoApiKeyUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}